<template>
    <div class="ingredient">
        <div style="color: red">
            请核对信息与「对应识别图片」中包含信息一致，此模块信息直接在前端展示给用户
        </div>

        <mc-loading
            v-if="loading"
            style="width:500px"
        />

        <div v-else>
            <div
                v-for="(item,index) in innerValue"
                :key="item.uuId"
                class="ingredient-item"
            >
                <div class="ingredient-config">
                    <mc-configform
                        ref="configForm"
                        v-model="innerValue[index]"
                        :fields="ingredientFields"
                        :disabled="disabled"
                    >
                        <template slot="productName">
                            <mc-select
                                v-model="item.productName"
                                :source="productNameSource"
                                :disabled="disabled"
                                :disabled-ids="disabledIds"
                                allow-create
                                filterable
                                clearable
                                placeholder="回车新增子商品名称"
                            />
                        </template>

                        <template slot="ingredients">
                            <IngredientTextarea
                                v-model="item.ingredients"
                                :disabled="disabled"
                            />
                        </template>
                    </mc-configform>
                </div>

                <mc-button
                    type="primary"
                    :disabled="disabled"
                    @click="handleAddOrDelete(index)"
                >
                    {{ index ? '删除' : '新增' }}
                </mc-button>

                <div
                    v-if="usePicUrl && !index"
                    style="margin-left:20px; text-align: center;"
                >
                    <mc-image
                        style="width: 100px; height: 100px"
                        :src="usePicUrl"
                        :preview-url-list="[usePicUrl]"
                    />
                    <div>对应识别的图片</div>

                    <mc-button
                        v-if="!disabled"
                        type="primary"
                        @click="handleChangeIdentifyImg"
                    >
                        重新选择识别图片
                    </mc-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, getCurrentInstance } from '@vue/composition-api';
import IngredientTextarea from './IngredientTextarea';
import { defaultIngredients } from './config';

const ingredientFields = Object.freeze([
    {
        label: '子商品名称',
        slot: 'productName',
    },
    {
        label: '配料表',
        slot: 'ingredients',
    },
]);

export default {
    components: {
        IngredientTextarea,
    },
    props: {
        value: {
            type: Array,
            default: () => ([]),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        source: {
            type: Array,
            default: () => ([]),
        },
        loading: {
            type: Boolean,
            default: false,
        },
        usePicUrl: {
            type: String,
            default: '',
        },
    },

    setup(props) {
        const { proxy } = getCurrentInstance();

        const productNameSource = computed(() => props.source.map((item) => ({
            label: item.productName,
            value: item.productName,
        })));

        const innerValue = computed({
            get() {
                return props.value;
            },
            set(val) {
                proxy.$emit('input', val);
            },
        });

        const disabledIds = computed(() => (innerValue.value || []).map((item) => item.productName));

        const handleAddOrDelete = (index) => {
            if (!index) {
                innerValue.value.push(defaultIngredients());
                return;
            }
            innerValue.value.splice(index, 1);
        };

        // 重新选择识别图片
        const handleChangeIdentifyImg = () => {
            proxy.$emit('changeIdentifyImg', 'ingredient');
        };

        return {
            ingredientFields,

            productNameSource,
            innerValue,
            disabledIds,
            handleAddOrDelete,
            handleChangeIdentifyImg,
        };
    },
};
</script>

<style lang="scss" scoped>
    .ingredient-item {
        display: flex;
        align-items: center;
        width: 500px;
        margin-bottom: 20px;
        .ingredient-config {
            padding: 20px 20px 0 10px;
            border-radius: 10px;
            border: 1px solid #e0e0e0;
            margin-right: 30px;
        }
    }
    .ingredient-item {
        margin-bottom: 0px;
    }
</style>
